<template>
  <Tag
    class="text-sm font-semibold text-[#151515]"
    :severity="severity"
    :pt="{
      root: [
        severity === 'primary' ? 'bg-[#D4EFFF]' : '',
        severity === 'success' ? 'bg-[#D2F5A1]' : '',
        severity === 'wait' ? 'bg-[#DFC7FF]' : '',
        severity === 'pre-accept' ? 'bg-[#ABDB67] border border-[#70b709]' : '',
        severity === 'warning' ? 'bg-[#FFD5B1]' : '',
        severity === 'danger' ? 'bg-[#FBAEA4]' : ''
      ]
    }"
    >{{ status }}</Tag
  >
</template>

<script setup lang="ts">
import { computed } from 'vue'
import Tag from 'primevue/tag'
import { MORTGAGE_STAGE_LABELS } from '../../const'
import { Mortgage } from '../../types'

const props = defineProps<{
  mortgage: Mortgage
}>()

const status = computed(() => {
  const mortgageStatus = props.mortgage.stages.current
  return MORTGAGE_STAGE_LABELS[mortgageStatus]
})

const severity = computed(() => {
  const mortgageStatus = props.mortgage.stages.current

  if (mortgageStatus === 'app_create') {
    return 'primary'
  }

  if (mortgageStatus === 'app_wait') {
    return 'wait'
  }

  if (mortgageStatus === 'app_bank_note') {
    return 'warning'
  }

  if (mortgageStatus === 'app_cancel' || mortgageStatus === 'app_complete_decline') {
    return 'danger'
  }

  if (mortgageStatus === 'app_issued') {
    return 'success'
  }

  if (mortgageStatus === 'app_complete_accept' || mortgageStatus === 'app_wait_accept') {
    return 'pre-accept'
  }

  if (mortgageStatus === 'app_ending') {
    return 'warning'
  }

  return 'primary'
})
</script>
